export default __webpack_public_path__ + "static/media/rakic.7ed00a59.png";